// components/ToolsPage.jsx
import { useParams, useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { db } from '../constants/firebase';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { sections, toolCategories } from '../constants/menuItems';
import Loading from './Loading';
import Link from './Link';

function ToolsPage() {
  const { sectionId } = useParams();
  const navigate = useNavigate();

  let section = null;
  Object.values(sections).forEach(categoryGroup => {
    if (categoryGroup[sectionId]) {
      section = categoryGroup[sectionId];
    }
  });

  const [tools, setTools] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchTools = async () => {
      try {
        const toolsRef = collection(db, 'tools');

        const q = query(
          toolsRef, 
          where('section', '==', sectionId),
          where('status', '==', 'approved')
        );

        const querySnapshot = await getDocs(q);

        const toolsList = [];
        querySnapshot.forEach((doc) => {
          toolsList.push({ id: doc.id, ...doc.data() });
        });

        setTools(toolsList);
      } catch (error) {
        console.error('Fehler beim Laden der Tools:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchTools();
  }, [sectionId]);

  const groupedTools = tools.reduce((acc, tool) => {
    const cat = tool.category || 'company-owned';
    if (!acc[cat]) acc[cat] = [];
    acc[cat].push(tool);
    return acc;
  }, {});

  if (loading) {
    return (
      <Loading />
    );
  }

  return (
    <main className="px-8 py-12 max-w-6xl mx-auto">
      <div className="flex items-center gap-4 mb-8">
        <button
          onClick={() => navigate('/')}
          className="text-gray-400 hover:text-white"
        >
          ← Zurück
        </button>
      </div>

      <div className="flex items-center gap-3 mb-8">
        <div className={`${section.color} p-3 rounded-xl`}>
          <section.icon className="w-6 h-6 text-white" />
        </div>
        <h1 className="text-2xl font-semibold text-white">{section.label}</h1>
      </div>

      {Object.entries(groupedTools).map(([category, categoryTools]) => (
        <section key={category}>
          <h2 className="text-xl font-semibold text-white mb-6">{toolCategories[category]}</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
            {categoryTools.map((tool, index) => (
              <Link key={index} label={tool.label} link={tool.link} image={tool.image} info={tool.info} warning={tool.warning}/>
            ))}
          </div>
        </section>
      ))}

      {tools.length === 0 && (
        <div className="p-8 bg-gray-900 border border-gray-800 rounded-xl text-center">
          <strong className="text-gray-100">Keine Tools bisher verfügbar</strong>
          <p className="text-gray-500">Etwas vergessen? Oli Bescheid geben.</p>
        </div>
      )}
    </main>
  );
}

export default ToolsPage;